import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import { LinearProgress, useTranslate } from "react-admin";
import { useDropzone } from "react-dropzone";

import FileIcon from "../../atoms/FileIcon";
import { FileRecordType } from "../../pages/SharedRecords.types";
import { FileUploadInputPropsType } from "./FileUploader.types";

const inputContainerSx = {
  border: "2px solid",
  borderColor: "info.dark",
  backgroundColor: "info.main",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "10em",
  paddingX: 3,
  paddingY: 0,
  cursor: "pointer",
  marginBottom: 2,
};

export default function FileUploadInput(props: FileUploadInputPropsType) {
  const { dropzoneOptions = {}, isLoading = false, sx = {}, selectedFiles = [] } = props;

  const translate = useTranslate();

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone(dropzoneOptions);
  const elevation = isDragActive ? 1 : 0;

  const onFileClick = () => {
    open();
  };

  return (
    <Paper sx={{ ...inputContainerSx, ...sx }} elevation={elevation} {...getRootProps()}>
      <input {...getInputProps()} />

      {isLoading ? (
        <LinearProgress timeout={0} />
      ) : (
        <Box>
          {selectedFiles.length > 0 ? (
            <Box>
              {selectedFiles.map((file: File | FileRecordType) => (
                <Box
                  sx={{ display: "flex", cursor: "pointer" }}
                  key={file.name || (file as FileRecordType).original_filename}
                  onClick={onFileClick}
                >
                  <FileIcon mimeType={"unknown"} />
                  {file.name || (file as FileRecordType).original_filename}
                </Box>
              ))}
            </Box>
          ) : (
            translate("ra.input.file.upload_several")
          )}
        </Box>
      )}
    </Paper>
  );
}
